import { getPromotions } from '../actions/sdk.actions';
import { store } from '../store';

const CACHE_TIME = 5 * 60 * 1000; // 5 minutes

const getPromotionsWithCache = async () => {
  const { apiKey, userId, merchantId, delegatedMerchantId, merchantDetails } =
    store.config;
  const storeId = merchantDetails?.storeId || '';
  //MARK: We might need a better cache key, but this is what I have for now
  const cacheKey = `${apiKey}-${userId}-${storeId}`;
  const promotionProviderData = store.promotionProviderData;
  const existingData = promotionProviderData.get(cacheKey);

  if (existingData?.data && Date.now() - existingData.timestamp < CACHE_TIME) {
    return existingData.data;
  }

  const response = await getPromotions({
    apiKey,
    storeId,
    userId,
    merchantId,
    delegatedMerchantId,
  });

  promotionProviderData.set(cacheKey, {
    data: response,
    timestamp: Date.now(),
  });

  return response;
};

export { getPromotionsWithCache as getPromotions };
